/**
 * Shared consent URLs — sourced from envConfig so they can vary per environment.
 */

import { getConfig } from '../../../../config/envConfig';

const { consent } = getConfig();

/** Atlassian Privacy Policy. */
export const ATLASSIAN_PRIVACY_POLICY_URL = consent.privacyPolicyUrl;

/** Atlassian Customer Agreement (Terms of Use). */
export const ATLASSIAN_TERMS_OF_USE_URL = consent.termsOfUseUrl;
